import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { Container, Box, Typography, Link } from "@mui/material";
import TagManager from "react-gtm-module";
import Stepper from "../components/carrito/Stepper";
import CardProductoOrden from "../components/ordencompleda/CardProductoOrden";
import { urlServices } from "../helper/urlsBase";
import { useFetch } from "../hooks/useFetch";
import { clearCarritoAction } from "../actions/carrito";
import NotFound from "./NotFound";
import MetaComponent from "../components/shared/MetaComponent";
import Logo from "../assets/img/LogoPegaduro.png";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const OrdenCompletada_openpay = () => {
  const query = useQuery();
  const orderId = query.get("orderId");
  const payUrl = query.get("payUrl");
  const dispatch = useDispatch();
  //EEventos del inicio del carrito
  useEffect(() => {
    dispatch(clearCarritoAction());
    return;
  }, [dispatch]);
  // useEffect(() => {
  //     if(pedido){
  //       TagManager.dataLayer({

  //         dataLayer:{

  //           ecommerce: {
  //             products:pedido?.pedido?.productos,
  //             idOrder:pedido?.pedido?.id,
  //             total:pedido?.pedido?.total,
  //             subtotal:pedido?.pedido?.subtotal,
  //             direccion:pedido?.pedido?.direccion
  //           },
  //           event:"purchase",

  //           }})

  //         try{

  //           handleConversion()
  //         }
  //         catch(error){
  //           console.error("ERROR EN EL SEND TO GTM")
  //         }

  //     }
  // }, [pedido])

  // const handleConversion = () => {
  //   if (window.gtag) {
  //     window.gtag('event', 'conversion', {
  //       send_to: 'AW-11035100076/pScvCKj_qbAZEKyH-Y0p',
  //       value: pedido?.pedido?.total,
  //       currency: 'MXN',
  //       transaction_id: pedido?.pedido?.id
  //     });
  //   }
  // };

  return (
    <>
      <MetaComponent
        titulo="Orden completada"
        description="La orden se ha completado"
      />
      <Stepper stepp="ordencompletada" />
      <Container>
        <Box display="flex" justifyContent="center">
          <Box sx={{ width: 800 }}>
            <Box display="flex" justifyContent="center">
              <img
                src={Logo}
                style={{ width: 140, height: 180, marginBottom: 30 }}
                alt="logo"
              />
            </Box>
            <Box justifyContent="center">
              <Typography fontWeight="bold" align="center" variant="subtitle1">
                Gracias por su compra, ya puede pasar a pagar, con el siguiente formato
              </Typography>
              <Typography fontWeight="bold" align="center" variant="subtitle1">
                <Link
                  href={payUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  align="end"
                  underline="hover"
                >
                  Referencia de pago
                </Link>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default OrdenCompletada_openpay;
